import { render, staticRenderFns } from "./ServiceProviderCreate.vue?vue&type=template&id=55fbc49a&"
import script from "./ServiceProviderCreate.vue?vue&type=script&lang=ts&"
export * from "./ServiceProviderCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports